<div *ngIf="portInvoiceBaseDto">
  <h2>{{ portInvoiceBaseDto.name | uppercase }} Details</h2>
  <div>
    <span>id:</span>
    {{ portInvoiceBaseDto.id }}
  </div>
  <div>
    <label for="invoice-name">Invoice number:</label>
    <input
      id="invoice-name"
      [(ngModel)]="portInvoiceBaseDto.name"
      placeholder="Invoice name"
    />
  </div>
  <button type="button" (click)="goBack()">go back</button>
</div>
